import { Text } from 'blaze-ui/Text/Text'
import Styles from './MediaFileProcessingInfo.module.scss'
import { AnnotationInformation } from 'blaze-ui/icons'

export const MediaFileProcessingInfo = () => {
  return (
    <div className={Styles.infoContainer}>
      <div className={Styles.infoIcon}>
        <AnnotationInformation size={24} color="var(--dark-60)" />
        <Text variant="smallList" color="var(--dark-80)">
          Please note
        </Text>
      </div>
      <Text variant="placeholder" color="var(--dark-60)">
        Recently added Brand Kit images and video require a few minutes to process before Blaze can automatically use
        them.
      </Text>
    </div>
  )
}
